import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home.jsx';
import Login from './pages/Login.jsx'
import ProtectedRoute from './components/ProtectedRoute.jsx';
import {useEffect} from "react";
import { useConfig } from './configContext.js';
import './css/App.css';


function App() {
    const {
      viteTabTitle,
      faviconUrl,
    } = useConfig();

    useEffect(() => {
      document.title = viteTabTitle;
    }, [viteTabTitle]);

    // Empty keeps the favicon bundled in the image.
    useEffect(() => {
      if (!faviconUrl) return;
      const link = document.querySelector("link[rel~='icon']");
      if (link) link.href = faviconUrl;
    }, [faviconUrl]);

  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/calendars" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/login" element={<Login />}/>
    </Routes>
  );
}

export default App;
